import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuthSession from "../../../authPatient/hooks/useAuthSession";
import {
  confirmPayment,
  fetchCurrentPlan,
  fetchSubscription,
  fetchPaymentHistory,
} from "../../redux/thunks/paymentThunks";
import { PAYMENT_ROUTES } from "../../routePaths";
import "./PaymentStatus.css";

export default function PaymentSuccess() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { effectiveUserId } = useAuthSession({ auto: true });
  const userId = effectiveUserId || searchParams.get("uid");
  const backRoute =
    searchParams.get("userType") === "doctor" ? "/subscription" : PAYMENT_ROUTES.PLANS;
  const ranRef = useRef(false);

  useEffect(() => {
    if (!userId) return;
    if (ranRef.current) return;
    ranRef.current = true;
    const paymentId = searchParams.get("payment_id");

    // The Flouci webhook is fire-and-forget and not guaranteed to land
    // (especially in sandbox), so confirm directly with the payment_id from
    // the redirect before refreshing plan/subscription/history. confirmPayment
    // re-verifies with Flouci and is a no-op if the webhook already landed.
    const run = async () => {
      if (paymentId) {
        try {
          await dispatch(confirmPayment(paymentId)).unwrap();
        } catch {
          // ignore — still refresh below in case the webhook confirmed it
        }
      }
      dispatch(fetchCurrentPlan(userId));
      dispatch(fetchSubscription(userId));
      dispatch(fetchPaymentHistory(userId));
    };
    run();
  }, [dispatch, userId, searchParams]);

  return (
    <div
      className="payment-status-page"
      dir={i18n.dir(i18n.resolvedLanguage || i18n.language)}
    >
      <div className="payment-status-card payment-status-card--success">
        <div className="payment-status-icon" aria-hidden="true">✓</div>
        <h1>{t("payment.result.success.title")}</h1>
        <p>{t("payment.result.success.message")}</p>
        <button type="button" onClick={() => navigate(backRoute)}>
          {t("payment.result.backToSubscription")}
        </button>
      </div>
    </div>
  );
}